<template>
  <v-card class="preview-card mx-auto">
    <v-img
      v-if="image"
      class="preview-card__img"
      height="350px"
      contain
      :src="image"
    >
    </v-img>

    <v-card-text class="text--primary pt-4">
      <p class="preview-card__header" v-if="data.event">
        {{ data.event.title }}
      </p>
      <div v-if="data.event && data.event.schedule">
        <div>
          <span v-if="isSameDay">{{ getStartDate }}</span>
          <span v-else>{{ getDateRange }}</span>
        </div>
      </div>
      <p class="pre-line mt-2 mb-8">{{ data.text }}</p>
      <a
        v-if="data.offer && data.offer.redeem_online_url"
        :href="data.offer.redeem_online_url"
        target="_blank"
        class="details-link"
      >
        {{ $t("message.offer.useOnline") }}
      </a>
      <PostsPreviewCouponCode
        v-if="data.offer && data.offer.coupon_code"
        :coupon-code="data.offer.coupon_code"
        :has-schedule="hasSchedule"
        :display-date="isSameDay ? getStartDate : getDateRange"
      />

      <div v-if="data.offer && data.offer.terms_conditions" class="">
        <div class="preview-card__main-text mt-4">
          {{ $t("message.offer.terms") }}
        </div>
        <p>
          {{ data.offer.terms_conditions }}
        </p>
      </div>
      <v-btn
        class="mt-4"
        color="primary"
        target="_blank"
        :href="data.call_to_action.url"
        v-if="data.call_to_action && data.call_to_action.type"
        >{{ buttonLabel }}</v-btn
      >
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { FORMAT } from "@/config/date-format";
import PostsPreviewCouponCode from "./PostsPreviewCouponCode.vue";
export default {
  name: "PostsViewDialog",
  components: { PostsPreviewCouponCode },
  props: {
    data: {
      type: Object,
      required: true
    },
    image: {
      type: String,
      required: false
    }
  },
  computed: {
    getDateFormat() {
      return this.hasSchedule ? FORMAT.DATE_HM : FORMAT.MM_DD_YYYY;
    },
    getStartDate() {
      return moment({
        ...this.data.event.schedule.start_date,
        month: this.data.event.schedule.start_date.month - 1,
        ...this.data.event.schedule.start_time
      }).format(this.getDateFormat);
    },
    getEndDate() {
      return moment({
        ...this.data.event.schedule.end_date,
        month: this.data.event.schedule.end_date.month - 1,
        ...this.data.event.schedule.end_time
      }).format(this.getDateFormat);
    },
    getDateRange() {
      return `${this.getStartDate} - ${this.getEndDate}`;
    },
    hasSchedule() {
      return (
        !!this.data.event.schedule.start_date &&
        !!this.data.event.schedule.end_date
      );
    },
    isSameDay() {
      const startDate = moment(this.data.event.schedule.start_date);
      const endDate = moment(this.data.event.schedule.end_date);
      return this.hasSchedule ? startDate.isSame(endDate, "day") : false;
    },
    buttonLabel() {
      const text = this.$t(`message.posts.callToAction`);
      return text[Object.keys(text)[this.data.call_to_action.type]];
    },
    formattedDate() {
      const { start_date } = this.data.event.schedule;

      return new moment(
        `${start_date.year}-${start_date.month}-${start_date.day}`
      ).format("D MMMM YYYY");
    }
  }
};
</script>

<style lang="scss" scoped>
.details-link {
  color: $primary !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  text-decoration: none;
  margin: $spacing * 1.5 0;
  display: block;
  text-transform: uppercase;
}

.preview-card {
  padding-bottom: $spacing;

  &__img {
    background: black;
  }
  &__header {
    @include font-size(18px);
    margin: $spacing 0 $spacing * 0.5 0;
    font-weight: 700;
    color: $grey-darker;
  }
  &__main-text {
    color: $grey-darker;
    font-weight: 600;
  }
  * {
    color: $gray-darker-2;
  }
}

.date-absolute {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  width: auto;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  padding: $spacing * 2 $spacing * 1.75;
  position: absolute;
  left: 0;
  top: 12px;
  color: $grey-darker;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}
</style>
